import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {routing} from '../../app.routing';
import {FormFieldsModule} from '~shared/components/form-fields/form-fields.module';
import {TablesModule} from '~shared/components/tables/tables.module';
import {ButtonsModule} from '~shared/components/buttons/buttons.module';
import {TooltipModule} from '~shared/components/tooltip/tooltip.module';
import {FormValidationModule} from '~core/components/form-validation/form-validation.module';
import {NotificationModule} from '~core/components/notification/notification.module';
import {SearchCustomerComponent} from "~features/search-customer/pages/search-customer.component";
import {AdvancedSearchComponent} from "~features/search-customer/pages/advanced-search/advanced-search.component";
import {BasicSearchComponent} from "~features/search-customer/pages/basic-search/basic-search.component";

/**
 * Module for the customer search section
 */
@NgModule({
  declarations: [
    SearchCustomerComponent,
    AdvancedSearchComponent,
    BasicSearchComponent,
  ],
  exports: [
    SearchCustomerComponent,
    AdvancedSearchComponent,
    BasicSearchComponent,
  ],
  imports: [
    CommonModule,
    TablesModule,
    ButtonsModule,
    routing,
    FormsModule,
    ReactiveFormsModule,
    FormValidationModule,
    NotificationModule,
    FormFieldsModule,
    TooltipModule
  ]
})
export class SearchCustomerModule {
}
